import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import RequireAuth from "./auth/RequireAuth";
import ErrorBoundary from "./components/ErrorBoundary";

import FinancialOverviewDashboard from "./pages/financial-overview-dashboard";
import VisaoGeralDashboard from "./pages/visao-geral";
import AccountsReceivableManagementDashboard from "./pages/accounts-receivable-management-dashboard";
import BillingAutomationDashboard from "./pages/billing-automation-dashboard";
import AccountsPayableManagementDashboard from "./pages/accounts-payable-management-dashboard";
import InventoryAnalyticsDashboard from "./pages/inventory-analytics-dashboard";
import EstoqueProdutoAcabadoPage from "./pages/estoque-produto-acabado";
import ControleProducaoPage from "./pages/controle-producao";
import BusinessIntelligenceReportingDashboard from "./pages/business-intelligence-reporting-dashboard";
import MercosRotasDashboard from "./pages/mercos-rotas-dashboard";
import MercosRotasPlanejadasPage from "./pages/mercos-rotas-planejadas";
import ComercialDashboardPage from "./pages/comercial-dashboard";
import PromotorDeVendasPage from "./pages/promotor-vendas";
import FinanceiroDashboardPage from "./pages/financeiro";
import FluxoCaixaPage from "./pages/financeiro/fluxo-caixa";
import InadimplenciaFinanceiraPage from "./pages/financeiro/inadimplencia";
import TasksPage from "./pages/tasks";
import AdministrationPage from "./pages/administration";
import BudgetComercialPage from "./pages/budget-comercial";
import ControleDegustacaoPage from "./pages/controle-degustacao";
import ProcessManagementPage from "./pages/process-management";
import SuperJhonnyPage from "./pages/super-jhonny";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";

const protectedPage = (permission, Component) => <RequireAuth permission={permission}><Component /></RequireAuth>;

const Routes = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <RouterRoutes>
        <Route path="/" element={<Navigate to="/visao-geral" replace />} />
        <Route path="/login" element={<Login />} />

        <Route path="/visao-geral" element={protectedPage("overview", VisaoGeralDashboard)} />
        <Route path="/financeiro" element={protectedPage("finance", FinanceiroDashboardPage)} />
        <Route path="/financeiro/fluxo-caixa" element={protectedPage("finance", FluxoCaixaPage)} />
        <Route path="/financeiro/inadimplencia" element={protectedPage("finance", InadimplenciaFinanceiraPage)} />
        <Route path="/financeiro/dre" element={protectedPage("finance", FinancialOverviewDashboard)} />
        <Route path="/financeiro/contas-receber" element={protectedPage("finance", AccountsReceivableManagementDashboard)} />
        <Route path="/financeiro/cobrancas-automaticas" element={protectedPage("finance", BillingAutomationDashboard)} />
        <Route path="/financeiro/contas-pagar" element={protectedPage("finance", AccountsPayableManagementDashboard)} />

        <Route path="/financial-overview-dashboard" element={<Navigate to="/visao-geral" replace />} />
        <Route path="/accounts-receivable-management-dashboard" element={<Navigate to="/financeiro/contas-receber" replace />} />
        <Route path="/billing-automation-dashboard" element={<Navigate to="/financeiro/cobrancas-automaticas" replace />} />
        <Route path="/accounts-payable-management-dashboard" element={<Navigate to="/financeiro/contas-pagar" replace />} />

        <Route path="/inventory-analytics-dashboard" element={protectedPage("stock", InventoryAnalyticsDashboard)} />
        <Route path="/estoque-produto-acabado" element={protectedPage("finished_stock", EstoqueProdutoAcabadoPage)} />
        <Route path="/pcp" element={protectedPage("pcp", ControleProducaoPage)} />
        <Route path="/controle-producao" element={<Navigate to="/pcp" replace />} />
        <Route path="/business-intelligence-reporting-dashboard" element={protectedPage("overview", BusinessIntelligenceReportingDashboard)} />
        <Route path="/mercos-rotas-dashboard" element={protectedPage("mercos_routes", MercosRotasDashboard)} />
        <Route path="/mercos-rotas-planejadas" element={protectedPage("manual_routes", MercosRotasPlanejadasPage)} />
        <Route path="/comercial" element={protectedPage("commercial", ComercialDashboardPage)} />
        <Route path="/promotor-vendas" element={protectedPage("ipdv_promoter", PromotorDeVendasPage)} />
        <Route path="/budget-comercial" element={protectedPage("commercial_budget", BudgetComercialPage)} />
        <Route path="/controle-degustacao" element={protectedPage("tastings", ControleDegustacaoPage)} />
        <Route path="/processos" element={protectedPage("processes", ProcessManagementPage)} />
        <Route path="/super-jhonny" element={protectedPage("super_jhonny", SuperJhonnyPage)} />
        <Route path="/tarefas" element={protectedPage("tasks", TasksPage)} />
        <Route path="/administracao" element={protectedPage("admin", AdministrationPage)} />

        <Route path="/sem-acesso" element={<RequireAuth><div className="flex min-h-screen items-center justify-center bg-[#f7ecd9] px-6 text-center text-[#4b2e23]"><div><h1 className="text-2xl font-bold">Nenhuma área liberada</h1><p className="mt-2 text-[#7a5c46]">Peça a um administrador para liberar pelo menos uma categoria para seu usuário.</p></div></div></RequireAuth>} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  </BrowserRouter>
);

export default Routes;
